import React from "react";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonGroup = ({
  font,
  color,
  width,
  description,
  borderRadius,
  count,
  backgroundColor,
}) => {
  const textLeft = {
    textAlign: "left",
  };
  return (
    <div style={{ display: "inline-block" }}>
      <button
        style={{
          fontFamily: font,
          color: color[0],
          width: "160px",
          borderRadius,
          marginRight: "10px",
          borderWidth: "1px",
          height: "61px",
          borderColor: "black",
          backgroundColor: backgroundColor[0],
        }}
      >
        <FontAwesomeIcon
          icon={faUpload}
          style={{
            marginRight: "5px",
            marginTop: "5px",
            verticalAlign: "top",
            display: "inline-block",
            width: "28px",
            height: "28px",
            padding: "4px 2px",
            borderRadius: "50%",
            border: "0.1px solid blue",
            backgroundColor: "#dce9ff",
            transform: "translate(-16px, 7px)",
            color: "#307BF6",
          }}
        />

        <span style={{ fontSize: "0.8em", fontWeight: "bold" }}>
          {description[0]}
        </span>
        <br />
        <span
          style={{
            fontSize: "1.3em",
            fontWeight: "bold",
            display: "block",
            transform: "translate(-7px, -8px)",
          }}
        >
          {count[0]}
        </span>
      </button>
      <button
        style={{
          fontFamily: font,
          color: color[1],
          width: "160px",
          borderRadius,
          marginRight: "10px",
          borderColor: "transparent",
          backgroundColor: backgroundColor[1],
          textAlign: "left",
        }}
      >
        <span style={{ fontSize: "0.8em", fontWeight: "bold" }}>
          {description[1]}
        </span>
        <br />
        <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>
          {count[1]}
        </span>
      </button>
      <button
        style={{
          fontFamily: font,
          color: color[2],
          borderRadius,
          width: "160px",
          marginRight: "10px",
          borderColor: "transparent",
          backgroundColor: backgroundColor[2],
          textAlign: "left",
        }}
      >
        <span style={{ fontSize: "0.8em", fontWeight: "bold" }}>
          {description[2]}
        </span>
        <br />
        <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>
          {count[2]}
        </span>
      </button>
      <button
        style={{
          fontFamily: font,
          color: color[3],
          borderRadius,
          width: "160px",
          marginRight: "10px",
          borderColor: "transparent",
          backgroundColor: backgroundColor[3],
          textAlign: "left",
        }}
      >
        <span style={{ fontSize: "0.8em", fontWeight: "bold" }}>
          {description[3]}
        </span>
        <br />
        <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>
          {count[3]}
        </span>
      </button>
    </div>
  );
};

export default ButtonGroup;
